import React from 'react';

export const HeadersContext = React.createContext({ headers: { authToken: "", systemUser: "" }, setHeaders: () => {} });
